<div class="po-row cp-header cp-div-itens-center">
  <div class="cp-div-itens"  >
    <span class="cp-title-bar">{{ literalsCp?.strTituloTotvs }} | TOTVS SA</span>
  </div>
  <div class="cp-mouse-pointer" style="margin-right: 20px; width: fit-content;">

    <po-popover style="width: fit-content;"
    #popover
    p-hide-arrow="false"
    p-position="bottom-left"
    [p-target]="poAvatar"
    p-trigger="click" >

      <div class="po-row">
        <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3">
          <img [src]="Logototvsmedium" alt="">
        </div>
        <div class="po-xl-9 po-lg-9 po-md-9 po-sm-9 cp-div-itens-center" style="width: fit-content;">
          <span class="cp-info-context">{{ literalsCp?.strUsuario }} {{ User }}</span>
        </div>
      </div>
      <hr class="cp-divisor-row">
      <div class="po-row">
       <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" (click)="openModal()">
        <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3" style="width: fit-content; padding: 0px;">
          <span class="po-icon po-icon-settings cp-info-context" #TrocarProjetoIcon></span>
        </div>
        <div class="po-xl-9 po-lg-9 po-md-9 po-sm-9">
          <span class="cp-info-context" #TrocarProjetoText>{{ literalsCp?.strTrocarProjeto }}</span>
        </div>
       </div>
      </div>
      <hr class="cp-divisor-row">
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12" (click)="Logout()">
         <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3" style="width: fit-content; padding: 0px;">
           <span class="po-icon po-icon po-icon-exit cp-info-context"></span>
         </div>
         <div class="po-xl-9 po-lg-9 po-md-9 po-sm-9">
           <span class="cp-info-context">{{ literalsCp?.strSair }}</span>
         </div>
        </div>
       </div>
    </po-popover>

    <po-avatar
    #target
    p-size="xs"
    [p-src]="Logototvssmall">
    </po-avatar>
  </div>
</div>
<div class="po-row cp-div-shadow"></div>

<cp-contextmodal></cp-contextmodal>

